import { CSSProperties } from 'react'

// Раскрытая строка стоит на месте при горизонтальной прокрутке таблицы шириной видимой области
// без закреплённых справа колонок. Раскладка — в _table.css (sticky-expanded-row).
// Обёртку строки делает antd (.ant-table-expanded-row-fixed): она появляется, только если
// у таблицы есть закреплённые колонки и scroll.x

interface StickyColumn {
  fixed?: boolean | string
  width?: string | number
}

/** Класс таблицы (обёртки antd): контейнер прокрутки становится container, от него считается 100cqw. */
export const STICKY_EXPANDED_ROWS_CLASS = 'sticky-expanded-rows'

/** Класс tr раскрытой строки — для expandable.expandedRowClassName. */
export const STICKY_EXPANDED_ROW_CLASS = 'sticky-expanded-row'

/** Стиль таблицы с суммой ширин закреплённых справа колонок — её вычитаем из ширины раскрытой строки. */
export const stickyExpandedRowsStyle = (columns: StickyColumn[] = [], style?: CSSProperties) =>
  ({
    ...style,
    '--fixed-right-width': `${columns
      .filter(({ fixed }) => fixed === 'right')
      .reduce((sum, { width }) => sum + (parseFloat(`${width ?? 0}`) || 0), 0)}px`,
  } as CSSProperties)
